<template>
  <div class="overall-bg pt-0">
    <b-container>
      <b-row class="stepperdiv">
        <b-col lg="6" md="6" sm="6" cols="2">
          <BackBtn :goback="$router.back" />
          <Headerlayout
            v-if="paramValue == 'IndirectIssue'"
            :headertext="$t('IndirectIssue.title')"
            :contenttext="$t('IndirectIssue.contents')"
          ></Headerlayout>
          <Headerlayout
            v-if="paramValue == 'DirectIssue'"
            :headertext="$t('DirectIssue.title')"
            :contenttext="$t('DirectIssue.contents')"
          ></Headerlayout>
          <Headerlayout
            v-if="paramValue == 'IssueReturn'"
            :headertext="$t('IssueReturn.title')"
            :contenttext="$t('IssueReturn.contents')"
          ></Headerlayout>
        </b-col>
        <b-col
          lg="6"
          md="6"
          sm="6"
          cols="2"
          v-if="items.length != 0 && !afterSave"
        >
          <Footer
            class="pb-3"
            @save="SubmitFunc()"
            :goback="$router.back"
            :label="label"
          />
        </b-col>
      </b-row>
      <b-row class="form-white-bg">
        <div>
          <Issue
            :showone="paramValue"
            v-model="remarks"
            :storeDetails="requestForm"
          />
          <IssuePopup
            v-if="paramValue == 'DirectIssue'"
            :showone="paramValue"
            :storeDetails="IssusePopupProps"
            @getstorevalue="getstorevalue"
          />
          <b-col
            lg="6"
            md="4"
            sm="6"
            cols="12"
            class="d-flex"
            v-if="!afterSave"
          >
            <div class="field">
              <label>{{ $t("Request.uploadquotation") }}</label>
              <input
                type="file"
                :multiple="true"
                id="actual-btn"
                @change="handleChangedocument"
                ref="fileInput"
                style="display: none"
              />
              <label id="custom-btn" for="actual-btn" class="flbtn">
                <i class="pi pi-upload" style="color: slateblue"></i>
                Choose File</label
              >
            </div>
          </b-col>
          <b-row>
            <b-col
              lg="3"
              md="4"
              sm="6"
              cols="12"
              class="d-flex"
              v-for="item in uploadedTableList"
            >
              <div class="fileuploadcard my-2" :title="item.fileName">
                <div>
                  <p class="filenametxt">{{ item.fileName }}</p>
                  <div
                    class="blue-txt"
                    id="file-name"
                    @click="fileviewer(item.fullPath)"
                  >
                    view
                  </div>
                </div>
                <DeleteIcon @click="fileuploadDelete(item)" />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="ObjCamp.IsCamp && ObjCamp.CampDetailCard">
            <p class="fn14 fw500">Camp Details</p>
            <b-col lg="6" md="6" class="campdetailscard">
              <b-row>
                <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Institute name:</p>
                  <p class="fn14 fw500">{{ ObjCamp.InstituteName }}</p>
                </b-col>
                <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Camp date:</p>
                  <p class="fn14 fw500">
                    {{ ObjCamp.FormattedCampDate }}
                  </p>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  lg="8"
                  md="8"
                  class="d-flex align-items-center gap-2 py-2"
                >
                  <p class="light-txt">Camp type:</p>
                  <p class="fn14 fw500">{{ ObjCamp.CampType }}</p>
                </b-col>
                <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Expected IP:</p>
                  <p class="fn14 fw500">{{ ObjCamp.ExpectedIP }}</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Camp name:</p>
                  <p class="fn14 fw500">{{ ObjCamp.CampName }}</p>
                </b-col>
                <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                  <p class="light-txt">Expected OP:</p>
                  <p class="fn14 fw500">{{ ObjCamp.ExpectedOP }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-col class="d-flex flex-row-reverse" v-if="afterSave">
            <div class="colourCodeStatusBg">
              <div class="confirmationtime" v-for="i1 in colourCodeList">
                <div class="d-flex align-items-center gap-2">
                  <div
                    class="confirmedicon"
                    :style="{ backgroundColor: i1.OrderColor }"
                  ></div>
                  <p>{{ i1.StatusName }}</p>
                </div>
              </div>
            </div>
          </b-col>
          <b-row v-if="paramValue == 'DirectIssue' && requestForm.status == 1">
            <b-col lg="3" md="3" sm="6" cols="12" class="my-3">
              <Datepicker
                class="date"
                label="From Date"
                name=""
                id=""
                v-model="FromDate"
                @date-select="LoadDocNo(FromDate, ToDate)"
              />
            </b-col>
            <b-col lg=" 3" md="3" sm="6" cols="12" class="my-3">
              <Datepicker
                class="date"
                label="To Date"
                name=""
                id=""
                v-model="ToDate"
                @date-select="LoadDocNo(FromDate, ToDate)"
              />
            </b-col>
            <b-col lg="3" md="3" sm="6" cols="12" class="my-3">
              <CustomMultiSelect
                :label="$t('issue.grnno')"
                placeholder="Select GRN No"
                v-model="DocNo"
                :items="DocNoOpiton"
                @update:modelValue="GetItemDetails"
                ref=" multiRef"
              />
            </b-col>
          </b-row>
          <b-row
            v-if="paramValue == 'DirectIssue' || paramValue == 'IssueReturn'"
          >
            <b-col class="d-flex flex-row-reverse pb-3">
              <p
                class="add-items d-flex d-flex-row-reverse"
                v-b-toggle.collapse-3
              >
                + Add Items
              </p>
            </b-col>
          </b-row>
          <b-row
            v-if="paramValue == 'DirectIssue' || paramValue == 'IssueReturn'"
          >
            <b-col>
              <b-collapse id="collapse-3" visible :class="displayClass">
                <Items
                  @additemclick="AddItems"
                  :show-fields="showFields"
                  v-model:data-items="dataItems"
                  :addItemData="items"
                  :isFilterData="itemDatas"
                  :commonItemProps="commonItemProps"
                />
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <!-- <MasterEmpty v-if="items.length == 0" :masteremptycontent="true" eheader="Item Issue" econtent="Item"
          eimg="/src/assets/Img/icons/itemmaster.svg" :createline="false" /> -->
        <!-- {{ items }} -->
        <!-- <div v-for="item in items" :key="item.Id">
          <p>
            UOM:{{ item.UOM }}brand:{{ item.Brand }} - ModelNumeber:{{
              item.ModelNumber
            }}
            - Size:{{ item.Size }} -Replacedbrand:
            {{ item.ReplacedBrand }} ReplacedModelNumeber:
            {{ item.ReplacedModelNumber }} ReplacedSize: {{ item.ReplacedSize }}
          </p>
        </div> -->
        <!-- {{ items }} -->
        <Table
          v-model:value="items"
          :paginator="true"
          class="p-datatable-gridlines"
          :rows="10"
          dataKey="id"
          :rowHover="true"
          filterDisplay="menu"
          :loading="loading1"
          responsiveLayout="scroll"
          :columns="headers"
          :seriaNlumber="true"
          @updatedata="Itemschanges"
          :addnewbtn="$route.query.param == 'IndirectIssue' ? true : false"
        >
          <template v-slot:Add>
            <span v-if="!afterSave">
              <AddButton
                @click="handleAutofill"
                btnname="Autofill"
                class="me-3"
              ></AddButton>
            </span>
          </template>
          <template v-slot:UOMSlot="{ data }">
            <span v-if="data.Editable">
              <CustomDropdown
                :items="data.UOMoption"
                v-model="data.UOM"
                :showClear="false"
                @update:modelValue=""
              >
              </CustomDropdown>
            </span>
            <span v-else @click="ShowUOMDropdown(data)">{{
              data.UOMName
            }}</span>
          </template>

          <template v-slot:Itemname1="{ data }">
            <span :style="getColorStyle(data)">
              {{ data.Itemname1 }}
            </span>
          </template>

          <template v-slot:RequestedQuantity="{ data }">
            {{ data.RequestedQty }}
          </template>

          <template v-slot:ItemQuantity="{ data, rowIndex }">
            <!-- {{ rowIndex }} -->
            <div class="label-d-none tablefield mb-0">
              <InputText
                type="text"
                placeholder=""
                @keyup="reqQtyToQty(data)"
                clearable
                :name="`'ItemQuantity'${data.index}`"
                :id="`'ItemQuantity'${data.index}`"
                label=""
                v-model="data.ItemQuantity"
                :rules="{ required: false, numeric: true }"
                :requiredIcon="false"
                :disabled="
                  data.DeleteFlag || afterSave || data.ToStoreCategoryItem == 0
                "
              />
            </div>
          </template>
          <template v-slot:ReasonSlot="{ data, rowIndex }">
            <div class="label-d-none tablefield mb-0">
              <InputText
                type="text"
                placeholder=""
                @keyup="reqQtyToQty(data)"
                clearable
                :name="`'Reason'${data.index}`"
                :id="`'Reason'${data.index}`"
                label=""
                v-model="data.DeletedReason"
                :rules="{ required: false, numeric: true }"
                :requiredIcon="false"
                :disabled="
                  data.DeleteFlag || afterSave || data.ToStoreCategoryItem == 0
                "
              />
            </div>
          </template>

          <template v-slot:ExpiryDate="{ data }">
            {{
              data.ExpiryDate == "01-01-0001" || data.ExpiryDate == "01-01-1900"
                ? ""
                : data.ExpiryDate
            }}
          </template>
          <template v-slot:StockInHandSlot="{ data }">
            {{ data.StockInHand }}
          </template>
          <template v-slot:ItemCategorySlot="{ data }">
            <p>
              {{ data.ItemCategory1 }}
            </p>
            <p
              v-if="data.ToStoreCategoryItem == 0"
              class="text-center"
              style="color: red"
            >
              (Category Not Mapped)
            </p>
          </template>
          <template v-slot:ModelNumberNameSlot="{ data }">
            <p
              v-if="
                data.BrandName == null &&
                data.ModelNumberName == null &&
                data.SizeName == null
              "
            >
              <span :style="getColorStyle(data)">
                {{ "-" }}
              </span>
            </p>
            <p v-else>
              <span :style="getColorStyle(data)">
                {{ data.BrandName != null ? data.BrandName : "-" }} /
                {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }}
                /
                {{ data.SizeName != null ? data.SizeName : "-" }}
              </span>
            </p>
          </template>

          <template v-slot:ReplacedModelNumberNameSlot="{ data }">
            <p v-if="data.ReplacementFlag">
              <span style="color: blue; font-weight: bold">
                {{
                  data.ReplacedBrandName != null ? data.ReplacedBrandName : "-"
                }}
                /
                {{
                  data.ReplacedModelNumberName != null
                    ? data.ReplacedModelNumberName
                    : "-"
                }}
                /
                {{
                  data.ReplacedSizeName != null ? data.ReplacedSizeName : "-"
                }}
              </span>
            </p>
            <p v-else>-</p>
          </template>

          <template v-slot:action="{ data }">
            <!-- <span v-if="!data.DeleteFlag && !afterSave">
              <DeleteIcon @click="IsConfirmDel(data)" />
            </span> -->
            <span v-if="!data.DeleteFlag && !afterSave">
              <Button
                icon="pi pi-ellipsis-v"
                class="p-button-rounded editicon p-button-text"
                @click="toggle($event, data)"
              />
            </span>
          </template>
        </Table>
      </b-row>
    </b-container>
  </div>
  <div class="center" v-if="loading1">
    <Loader :loading="loading1" />
  </div>
  <Toast />
  <Menu ref="menu" id="overlay_menu" :model="itemList" :popup="true" />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsItemEdit(dataEdit)"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <EditConfirmation
    :Editmodel="modelQty"
    @yes="IsSubmit"
    @no="modelQty = false"
    content="Item List has 0 Quantity.Do you want proceed without adding that item?"
  />
  <DeleteConfirmationVue
    :DeleteModel="Deletemodel"
    @yes="IsItemDelete(dataEdit)"
    @no="Deletemodel = false"
  />
  <DeletedSuccessfully :visible="deletepop" @ok="deleteclosetrigger()" />
  <CrystalReportPrintPopUp
    :ShowAndHide="CrystalReportPopup"
    :ParameterValues="ParameterValues"
    :PrintType="PrintType"
  />
  <AlreadyExist
    :selectedcontent="selectedcontent"
    :visible="alreadyexistpop"
    @ok="alreadyclosetrigger()"
  />
  <Dialog
    class="replacement-dialog"
    :modal="true"
    v-model:visible="ReplacementTableFlag"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '80vw' }"
    header=""
    @after-hide="$.emit('close')"
  >
    <template #header>
      <div class="replacement-dialog-header">
        <h3 class="m-0">{{ $t("issue.replacementiltemlist") }}</h3>
      </div>
    </template>

    <div class="replacement-item-details p-3 mb-4">
      <div class="row">
        <div class="col-md-6">
          <div class="info-group mb-3">
            <span class="info-label">Pending Items for Issue:</span>
            <span class="info-value">{{ IssueCount }}</span>
          </div>
          <div class="info-group mb-3">
            <span class="info-label">Category:</span>
            <span class="info-value">{{
              currentReplacementItem?.ItemCategory1 || "-"
            }}</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="info-group mb-3">
            <span class="info-label">Code:</span>
            <span class="info-value">{{
              currentReplacementItem?.ItemProductId || "-"
            }}</span>
          </div>
          <div class="info-group mb-3">
            <div class="d-flex">
              <div class="me-4">
                <span class="info-label">Requested Qty:</span>
                <span class="info-value">{{
                  currentReplacementItem?.RequestedQty || "0"
                }}</span>
              </div>
              <div>
                <span class="info-label">Issued Qty:</span>
                <span class="info-value">{{
                  currentReplacementItem?.IssuedQuantity || "0"
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="divider mb-4"></div>
    <MasterEmpty
      v-if="ReplacementItemsList.length === 0"
      eheader="No Stock Available"
      :createline="false"
      :masteremptycontent="false"
      eimg="/src/assets/Img/icons/master.svg"
    />

    <Tableview
      v-if="ReplacementItemsList.length !== 0"
      :value="ReplacementItemsList"
      :paginator="true"
      class="p-datatable-gridlines"
      dataKey="Id"
      :rowHover="true"
      filterDisplay="menu"
      responsiveLayout="scroll"
      :rows="10"
      :columns="Replacementheaders"
      @row-click=""
      :globalFilterFields="globalFilterFields"
      :filters="filters"
    >
      <template v-slot:checkBoxSlot="{ data }">
        <div class="align-items-center pt-2">
          <Checkbox
            :inputId="`${data.Id}_read`"
            :name="`Read_${data.Id}`"
            v-model="data.CheckFlag"
            value="true"
            @change="Replacementcheck(data)"
          />
        </div>
      </template>
      <template v-slot:UOMSlot="{ data }">
        <span v-if="data.Editable">
          <CustomDropdown
            :items="data.UOMoption"
            v-model="data.UOM"
            :showClear="false"
            @update:modelValue=""
          >
          </CustomDropdown>
        </span>
        <span v-else @click="ShowUOMDropdown(data)">{{ data.UOMName }}</span>
      </template>

      <template v-slot:Itemname1="{ data }">
        <span>
          {{ data.Itemname1 }}
        </span>
        <span class="spantxt">
          {{ data.BarCode }}
        </span>
      </template>

      <template v-slot:ItemQuantity="{ data, rowIndex }">
        <!-- {{ rowIndex }} -->
        <div class="label-d-none tablefield mb-0">
          <InputText
            type="text"
            placeholder=""
            @keyup="ReplacementreqQtyToQty(data)"
            clearable
            :name="`'ItemQuantity'${data.index}`"
            :id="`'ItemQuantity'${data.index}`"
            label=""
            v-model="data.ItemQuantity"
            :rules="{ required: false, numeric: true }"
            :requiredIcon="false"
            :disabled="
              data.DeleteFlag || afterSave || data.ToStoreCategoryItem == 0
            "
          />
        </div>
      </template>

      <template v-slot:ExpiryDate="{ data }">
        {{
          data.ExpiryDate == "01-01-0001" || data.ExpiryDate == "01-01-1900"
            ? ""
            : data.ExpiryDate
        }}
      </template>
      <template v-slot:StockInHandSlot="{ data }">
        {{ data.StockInHand }}
      </template>
      <template v-slot:ItemCategorySlot="{ data }">
        <p>
          {{ data.ItemCategory1 }}
        </p>
      </template>
      <template v-slot:ModelNumberNameSlot="{ data }">
        <p
          v-if="
            data.BrandName == null &&
            data.ModelNumberName == null &&
            data.SizeName == null
          "
        >
          {{ "-" }}
        </p>
        <p v-else>
          {{ data.BrandName != null ? data.BrandName : "-" }} /
          {{ data.ModelNumberName != null ? data.ModelNumberName : "-" }} /
          {{ data.SizeName != null ? data.SizeName : "-" }}
        </p>
      </template>
    </Tableview>
    <div class="d-flex justify-content-end mt-3">
      <Footer
        class="pb-3"
        @save="ConfirmIssue"
        label="Confirm"
        @cancel="ReplacementTableFlag = false"
      />
    </div>
  </Dialog>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  PropType,
  computed,
  onMounted,
  watch,
} from "vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import BackBtn from "../../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import Table from "../../../../../../components/FormComponents/NormalTable.vue";
import PurchaseOrder from "../../../../../../modules/Inventory/components/Transaction/PurchaseOrder.vue";
import IssuePopup from "../../../../../../modules/Inventory/components/Transaction/stockout/IssuePopup.vue";
import Issue from "../../../../../../modules/Inventory/components/Transaction/stockout/IssueComponent.vue";
import Items from "../../../../../../modules/Inventory/components/Transaction/Item.vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import { useRoute, useRouter } from "vue-router";
import Service from "../../../../../../modules/Inventory/Service/StockOutService";
import WithoutStockService from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import common from "../../../../../../modules/Inventory/Service/CommonService";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import commonservice from "../../../../../../modules/Inventory/Service/StoreService";
import StockWODetailsService from "../../../../Service/WithoutStockAffectService";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import commonService from "../../../../Service/StockInService";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import Datepicker from "../../../../../../components/FormComponents/DatePicker.vue";
import CrystalReportPrintPopUp from "../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import UnitMasterService from "../../../../../../modules/Inventory/Service/UnitMasService";
import commonServiceWO from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import { useI18n } from "vue-i18n";
import { setupHistoryManagement } from "../../../../../../modules/Inventory/Service/HistoryManage";
import StockInFileUploadServices from "../../../../../../modules/Inventory/Service/StockInFileUploadService";
import StockWOFileUploadServices from "../../../../../../modules/Inventory/Service/StockWOFileUploadService";
import Itemservice from "../../../../Service/ItemMasService";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import AutoComplete from "../../../../../../components/FormComponents/AutoComplete.vue";
import CustomMultiSelect from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import Tableview from "../../../../../../components/FormComponents/Table.vue";

export default defineComponent({
  components: {
    MasterEmpty,
    TextField,
    Datepicker,
    BackBtn,
    Headerlayout,
    Table,
    Items,
    Footer,
    PurchaseOrder,
    IssuePopup,
    Issue,
    CreateSuccessully,
    UpdatedSuccessfully,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    Loader,
    CrystalReportPrintPopUp,
    CustomDropdown,
    AlreadyExist,
    AutoComplete,
    CustomMultiSelect,
    Tableview,
  },

  setup(props, { emit }) {
    debugger;
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = session.BranchId;
    let UserId = Number(session.UserId);
    let Admin = Number(session.Admin);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    let selectedcontent = ref("Some Items has no stock");
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    const toast = useToast();
    const router = useRouter();
    const route = useRoute();
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const modelQty = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const dataEdit = ref();
    const itemDatas = ref([]);
    let DocNo = ref("");
    let FromDate = ref("");
    let ToDate = ref("");
    let OperationId = ref(0);
    let Entitydata = ref();
    const alreadyexistpop = ref(false);

    const display = ref(true);
    const displayClass = ref("");
    const dataItems = ref({});
    const CrystalReportPopup = ref(false);
    let afterSave = ref(false);
    let items: any = ref([]);
    let checkitem: any = ref([]);

    let ReplacementItemsList: any = ref([]);
    let ReplacementTableFlag = ref(false);
    let loading1 = ref(false);

    let List = ref([]);
    var arr: any = [];
    var checkstockAvailabilityresultarr: any = [];
    var Barcodearr: any = [];
    let currentDate = new Date().toISOString().slice(0, 10);
    let StockInTransId = 0;
    let showitemfield = ref(false);
    let showadditemfield = ref(true);
    let fullPath = ref();
    let uploadedTableList: any = ref([]);
    let DeletedFileUpload: any = [];
    const StockWOFileUpload = ref([]);
    const ParameterValues = ref({ Id: 0, BranchId: 0, HospitalId: 0 });
    const PrintType = ref({ Type: "S", FormId: 10, ModuleId: 3 });
    const label = ref(t("btn.save"));
    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );
    let showFields = {
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      AvailQty: {
        show: true,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      ExpiryDate: {
        show: true,
        require: true,
      },
      UOM: {
        show: true,
        require: true,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
    };
    let colourCodeList = ref([
      { OrderColor: "red", StatusName: "No Stock" },
      { OrderColor: "blue", StatusName: "Partially Issued" },
      { OrderColor: "green", StatusName: "Issued" },
    ]);
    const createrequestForm = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2023-03-27T12:32:26.939Z",
      ModifiedAt: "2023-03-27T12:32:26.939Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ApproverID: 0,
      TaskID: 0,
      IsApprovalRequired: true,
      ApprovalDate: "2023-03-27T12:32:26.939Z",
      TaskStatus: 0,
      TaskExpiryDate: "2023-03-27T12:32:26.939Z",
      TaskName: "",
      Taskpriority: 0,
      ResponseTimeInHours: 0,
      IsAutoApproval: true,
      IsApproved: 0,
      Id: 0,
      DocType: "",
      RefNo: "",
      DocNo: "",
      DocDate: "2023-03-27T12:32:26.939Z",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      DcNo: "",
      DcDate: "2023-03-27T12:32:26.939Z",
      InvoiceNo: "",
      InvoiceDate: "2023-03-27T12:32:26.939Z",
      InWardNo: "",
      InWardDate: "2023-03-27T12:32:26.939Z",
      Type: "",
      Status: "",
      AuthorizedStatus: true,
      CancelReason: "",
      Cancelled: true,
      RefId: 0,
      Remarks: "",
      SubDetailsAmount: 0,
      TaxAmount: 0,
      DiscountAmount: 0,
      Amount: 0,
      ClosedReason: "",
      Closed: true,
      Subject: "",
      HospitalId: 0,
      BranchId: 0,
      GrnPaymentType: "",
      CrNoteAmt: 0,
      DueAmount: 0,
      PatientId: "2",
      VisitId: 3,
      TempPatientId: 1,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      Channel: 0,
      OrderId: 0,
      RequestId: 0,
      RequestNo: "",
      RequestCreatedBy: 0,
      RequestCreatedBranch: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsDraft: 0,
    });

    const requestForm = ref({
      requestId: "",
      StockWOTransTMId: 0,
      StockOutTMId: 0,
      fromStoreId: ref(),
      fromStoreName: "",
      toStoreId: ref(),
      toStoreName: "",
      issueId: "",
      issueReturnId: "",
      status: 0,
      type: 0,
      StockInTransId: 0,
      Types: 0,
      fromStoreCode: "",
      toStoreCode: "",
      EntityId: 0,
      EntityOperationId: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      Channel: 0,
      OrderId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
    });

    const IssusePopupProps = ref({
      requestId: "",
      fromStoreId: 0,
      fromStoreName: "",
      fromStoreCode: "",
      FromStoreBrMapId: 0,
      toStoreId: 0,
      toStoreName: "",
      toStoreCode: "",
      ToStoreBrMapId: 0,
      issueId: "",
      issueReturnId: "",
      type: 0,
      StockOutTMId: 0,
      StockInTransId: 0,
    });
    const commonItemProps = ref({
      storeId: "",
      type: 1,
      fieldType: 0, //0-for Availability check 1- for IssuedQty check
      tostoreId: "",
      itemType: 3, //item type is for item autocomplete 0-only item label will show 1-item + barcode will show / 3-batch wise (will show barcode for batch and not for others)
      requestType: 0, //1-load item with barcode based on requested item
      IsFilter: 0,
      ToStoreBrMapId: 0,
      UOMFlag: true,
      DirectIssueFlag: true,
    });

    let remarks = ref({
      Remarks: "",
    });

    let ObjCamp: any = ref({
      CampDetailCard: false,
      IsCamp: false,
      CampId: ref(),
      InstituteName: "",
      CampName: "",
      CampType: "",
      CampDate: "",
      FormattedCampDate: "",
      ExpectedIP: "",
      ExpectedOP: "",
    });
    let IssueCount = ref(0);
    let currentReplacementItem = ref({
      ItemCategory1: "",
      ItemProductId: "",
      RequestedQty: 0,
      IssuedQuantity: 0,
      ItemId: 0,
      Brand: 0,
      ModelNumber: 0,
      Size: 0,
      BrandName: "",
      ModelNumberName: "",
      SizeName: "",
    });
    const paramValue = computed(() => {
      return route.query.param as string;
    });

    onMounted(async () => {
      debugger;
      await LoadFromStore();
      getParamsValue();
    });
    let FromStoreresult: any;
    let ToStoreresult: any;
    let DocNoOpiton: any = ref([]);
    const QueryValue = JSON.parse(route.query.data as string);

    async function LoadFromStore() {
      // FromStoreresult = await commonservice.getStoreListByUserId(
      //   UserId,
      //   HospitalId,
      //   Admin,
      //   BranchId
      // );
      FromStoreresult = await commonservice.StoreDropDownListByUserId(
        UserId,
        HospitalId,
        Admin,
        BranchId
      );
    }

    async function LoadToStore(StoreId) {
      debugger;
      ToStoreresult = await commonservice.getStoreByStoreId(
        StoreId,
        HospitalId,
        QueryValue.BranchId
      );
    }
    async function LoadDocNo(FromDate, ToDate) {
      debugger;
      if (FromDate && ToDate) {
        const fromDateFormatted = moment(FromDate).format("YYYY-MM-DD");
        const toDateFormatted = moment(ToDate).format("YYYY-MM-DD");
        const result = await commonService.GetDocNoByStoreId(
          requestForm.value.fromStoreId,
          QueryValue.BranchId,
          HospitalId,
          "",
          fromDateFormatted,
          toDateFormatted
        );
        DocNoOpiton.value = result["result"].map((items) => {
          items.name =
            items.DocNo +
            " - (" +
            "Invoice no: " +
            items.InvoiceNo +
            " , " +
            "Invoice date: " +
            items.InvoiceDate +
            ")";
          items.value = items.Id;
          return items;
        });
      }
    }
    async function GetItemDetails(event) {
      debugger;
      items.value = items.value.filter((item) => item.grntype !== 1);
      const docNoString: string = Array.isArray(DocNo.value)
        ? DocNo.value.join(",")
        : DocNo.value.split(",").join(",");
      let result = await commonService.GetStockInDetailsByRefId(
        docNoString,
        requestForm.value.toStoreId,
        requestForm.value.ToStoreBrMapId
      );

      if (result["result"]) {
        const existingBarcodes = new Set(
          items.value.map((item) => item.BarCodeNo)
        );
        const updatedItems = result["result"]
          .filter((item) => !existingBarcodes.has(item.BarCodeNo))
          .map((item) => ({ ...item, grntype: 1, RequestedQty: 0, Id: 0 }));

        items.value.push(...updatedItems);
      }
    }

    let FromStoreBranchId = 0;

    async function getParamsValue() {
      debugger;
      const data = route.query.data as string;
      const requestform1 = JSON.parse(data);
      let FileUploadresult: any;
      OperationId.value = requestform1["OperationId"];
      Entitydata.value = requestform1["EntityId"];
      requestForm.value.Types = requestform1["Types"];
      requestForm.value.StockInTransId = requestform1["StockTransId"];
      requestForm.value.issueId = requestform1["issueId"] ?? "";
      requestForm.value.issueReturnId = requestform1["issueReturnId"] ?? "";
      requestForm.value.StockWOTransTMId = requestform1["StockWOTransTMId"];
      requestForm.value.StockOutTMId = requestform1["StockOutTransTMId"];
      requestForm.value.status = requestform1["status"];
      requestForm.value.type = requestform1["type"];
      requestForm.value.requestId = requestform1["requestId"];
      requestForm.value.fromStoreId = requestform1["fromStoreId"];
      commonItemProps.value.storeId = requestform1["fromStoreId"];
      commonItemProps.value.tostoreId = requestform1["toStoreId"];
      requestForm.value.toStoreId = requestform1["toStoreId"];
      requestForm.value.toStoreName = requestform1["toStoreName"];

      requestForm.value.FromStoreBrMapId =
        requestform1["type"] == 1
          ? requestform1["ToStoreBrMapId"]
          : requestform1["storebranchmapid"];
      requestForm.value.StoreBrMapId =
        requestform1["type"] == 1
          ? requestform1["ToStoreBrMapId"]
          : requestform1["storebranchmapid"];
      requestForm.value.ToStoreBrMapId =
        requestform1["type"] == 1
          ? requestform1["FromStoreBrMapId"]
          : requestform1["ToStoreBrMapId"];
      requestForm.value.StockInTransId = requestform1?.["StockTransId"];
      FromStoreBranchId = requestform1?.["BranchId"];

      IssusePopupProps.value.requestId = requestform1["requestId"];
      IssusePopupProps.value.fromStoreId = requestform1["fromStoreId"];
      IssusePopupProps.value.fromStoreName = "";
      IssusePopupProps.value.fromStoreCode = "";
      IssusePopupProps.value.FromStoreBrMapId =
        requestForm.value.FromStoreBrMapId;
      IssusePopupProps.value.toStoreId = requestform1["toStoreId"];
      IssusePopupProps.value.toStoreName = "";
      IssusePopupProps.value.toStoreCode = "";
      IssusePopupProps.value.ToStoreBrMapId = requestForm.value.ToStoreBrMapId;
      IssusePopupProps.value.issueId = requestform1["issueId"] ?? "";
      IssusePopupProps.value.issueReturnId =
        requestform1["issueReturnId"] ?? "";
      IssusePopupProps.value.type = requestform1["type"];
      IssusePopupProps.value.StockOutTMId = requestform1["StockOutTransTMId"];
      IssusePopupProps.value.StockInTransId = requestform1?.["StockTransId"];
      IssusePopupProps.value.requestId = requestform1["requestId"];
      IssusePopupProps.value.fromStoreId = requestform1["fromStoreId"];
      IssusePopupProps.value.fromStoreName = "";
      IssusePopupProps.value.fromStoreCode = "";
      IssusePopupProps.value.FromStoreBrMapId =
        requestForm.value.FromStoreBrMapId;
      IssusePopupProps.value.toStoreId = requestform1["toStoreId"];
      IssusePopupProps.value.toStoreName = "";
      IssusePopupProps.value.toStoreCode = "";
      IssusePopupProps.value.ToStoreBrMapId = requestForm.value.ToStoreBrMapId;
      IssusePopupProps.value.issueId = requestform1["issueId"] ?? "";
      IssusePopupProps.value.issueReturnId =
        requestform1["issueReturnId"] ?? "";
      IssusePopupProps.value.type = requestform1["type"];
      IssusePopupProps.value.StockOutTMId = requestform1["StockOutTransTMId"];
      IssusePopupProps.value.StockInTransId = requestform1?.["StockTransId"];
      UOM();

      if (requestform1["type"] == "1" || requestform1["type"] == "2") {
        GetCode();
      }
      if (requestform1["type"] == "1") {
        IsShowByStockTransId(requestForm.value.StockWOTransTMId);
        showFields.RequestedQty.show = true;
        commonItemProps.value.requestType = 1;
        FileUploadresult = await StockWOFileUploadServices.getStockWOFileById(
          requestForm.value.StockWOTransTMId
        );
      } else if (
        requestform1["type"] == "2" &&
        requestForm.value.StockOutTMId != 0 &&
        requestForm.value.StockOutTMId
      ) {
        IsShowByStockOutId(requestForm.value.StockOutTMId);
        FileUploadresult = await StockInFileUploadServices.getStockInFileById(
          requestForm.value.StockOutTMId
        );
        if (
          requestForm.value.StockWOTransTMId &&
          requestForm.value.StockWOTransTMId != 0
        ) {
          IsShowByStockTransId(requestForm.value.StockWOTransTMId);
          showFields.RequestedQty.show = true;
          commonItemProps.value.requestType = 1;
        }
      } else if (
        requestform1["type"] == "3" &&
        requestform1["StockTransId"] &&
        requestform1["StockTransId"] != 0
      ) {
        if (
          requestform1["StockOutTransTMId"] &&
          requestform1["StockOutTransTMId"] != 0
        ) {
          IsShowByStockOutId(requestForm.value.StockOutTMId);
          FileUploadresult = await StockInFileUploadServices.getStockInFileById(
            requestForm.value.StockOutTMId
          );
        } else {
          GetIssueReturnCode();
        }
        IsShowByStockInId(requestform1["StockTransId"]);
        FileUploadresult = await StockInFileUploadServices.getStockInFileById(
          requestform1["StockTransId"]
        );
        commonItemProps.value.fieldType = 1;
        showFields.AvailQty.show = false;
        showFields.IssuedQty.show = true;
      }
      if (requestform1["type"] == 1) {
        getstorevalue(requestForm.value);
      }
      if (FileUploadresult["result"].length > 0) {
        for (let i = 0; i < FileUploadresult["result"].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] =
            FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
            (Fileobj["fileName"] =
              FileUploadresult["result"][i].FileName.split("/").pop()),
            (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
            (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
            (Fileobj["Id"] = FileUploadresult["result"][i].Id),
            uploadedTableList.value.push(Fileobj);
        }
      }
      await GetCampDetails();
    }

    let RequestCreatedBy = ref(0);
    let RequestCreatedBranch = ref(0);
    async function IsShowByStockTransId(StockTransTMId) {
      debugger;
      const result = await WithoutStockService.GetItemsByRequstIdCustom(
        StockTransTMId,
        HospitalId,
        FromStoreBranchId
      );

      console.log(result["result"]);
      itemDatas.value = result["result"];
      requestForm.value.Channel = result["result"][0]["Channel"];
      requestForm.value.OrderId = result["result"][0]["OrderId"];
      result["result"] = result["result"].map((i) => {
        i.Editable = false;
        return i;
      });

      let index = 0;
      items.value = result["result"].map((items) => {
        items.index = index;
        items.ItemQuantity = 0;
        items.DeleteFlag =
          items.DeletedReason != "" &&
          items.DeletedReason != undefined &&
          items.DeletedReason != null
            ? true
            : false;
        items.Asset = items.Asset;
        items.StockStatus = 3;
        items.StoreId = requestForm.value.fromStoreId || 0;
        items.BranchId = FromStoreBranchId || 0;
        items.HospitalId = HospitalId || 0;
        items.ToStoreCategoryItem = 1;
        index++;
        return items;
      });
      debugger;
      RequestCreatedBy.value = result["result"][0]?.CreatedBy;
      RequestCreatedBranch.value = result["result"][0]?.BranchId;
    }

    async function IsShowByStockInId(StockTransTMId) {
      debugger;
      const result = await commonService.getlistById(StockTransTMId);
      console.log(result["result"]);
      requestForm.value.fromStoreId = result["result"][0]["ToStore"];
      requestForm.value.toStoreId = result["result"][0]["FromStore"];
      commonItemProps.value.storeId = result["result"][0]["ToStore"];
      itemDatas.value = result["result"];
    }

    async function IsShowByStockOutId(StockOutTMId) {
      debugger;

      console.log(StockOutTMId);
      const result = await Service.GetById(StockOutTMId);
      console.log(result["result"]);
      if (requestForm.value.type == 3) {
        requestForm.value.issueReturnId = result["result"][0]["DocNo"];
        requestForm.value.issueId = result["result"][0]["RefNo"];
      }
      StockInTransId = result["result"][0]?.["StockInTransId"];
      remarks.value.Remarks = result["result"][0]["Remarks"];
      items.value = result["result"];
    }

    function ShowItems() {
      showitemfield.value = true;
      showadditemfield.value = false;
    }
    let actionReplacement = ref(false);
    let actionDelete = ref(false);
    let objectdata = ref({});
    const itemList = ref([
      {
        items: [
          {
            label: "Replacement",
            icon: "pi pi-user",
            visible: actionReplacement,
            command: async () => {
              ReplacementItem(objectdata);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: actionDelete,
            command: async () => {
              IsItemDelete(objectdata);
            },
          },
        ],
      },
    ]);
    const menu = ref();
    const toggle = (event, data) => {
      debugger;
      if (!data.ReplacementFlag) {
        actionReplacement.value = true;
      } else {
        actionReplacement.value = false;
      }

      actionDelete.value = true;

      objectdata = data;
      menu.value.toggle(event);
    };

    const headers = [
      {
        header: t("storetabdetails.issuecreationtable.Category"),
        field: "ItemCategory1",
        slot: "ItemCategorySlot",
        class: "smallwidth newcolumnfreezeleft1",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.issuecreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",

        slot: "Itemname1",

        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
      {
        header: t("storetabdetails.issuecreationtable.Brand/Model/Size"),
        field: "",
        slot: "ModelNumberNameSlot",
        bodyclass: "text_overflow2",
        class: "mediumwidth newcolumnfreezeleft4",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: "Replaced Brand/Model/Size",
        field: "",
        slot: "ReplacedModelNumberNameSlot",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.BatchNo"),
        field: "BatchNo",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.UOM"),
        field: "UOMId",
        slot: "UOMSlot",

        class: "smallwidth",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.ExpDate"),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
        class: "newcolumnfreezeleft5",
      },
      {
        header: t("storetabdetails.issuecreationtable.ToStoreAvlqty"),
        field: "ToStoreStockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.AvlQty"),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
      },
      {
        header: "Picked Qty",
        field: "PickedQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "InTransist Qty",
        field: "InTransist",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.reqQty"),
        field: "RequestedQty",
        slot: "RequestedQuantity",
        bodyclass: "right_td",

        class: "smallwidth",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
      {
        header: t("storetabdetails.issuecreationtable.IssuedQty"),
        field: "IssuedQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.Reason"),
        field: "Reason",
        slot: "ReasonSlot",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
      {
        header: t("storetabdetails.issuecreationtable.IssueQty"),
        field: "ItemQuantity",
        slot: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth columnfreezeright",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },

      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        // hide: ColumnVisible.value,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    };

    const Replacementheaders = [
      {
        header: "",
        ShowMactchMode: false,
        slot: "checkBoxSlot",
        fieldDisplay: "false",
        sortable: false,
        checkfield: true,
        class: "smallwidth newcolumnfreezeleft1",
      },

      {
        header: t("storetabdetails.issuecreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft2",
        slot: "Itemname1",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
      {
        header: t("storetabdetails.issuecreationtable.Brand/Model/Size"),
        field: "BatchNo",
        slot: "ModelNumberNameSlot",
        bodyclass: "text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.BatchNo"),
        field: "BatchNo",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.UOM"),
        field: "UOMId",
        slot: "UOMSlot",
        class: "smallwidth",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.issuecreationtable.ExpDate"),
        field: "ExpiryDate",
        slot: "ExpiryDate",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.ToStoreAvlqty"),
        field: "ToStoreStockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.issuecreationtable.AvlQty"),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
      },
      {
        header: "Picked Qty",
        field: "PickedQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: "InTransist Qty",
        field: "InTransist",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.issuecreationtable.IssueQty"),
        field: "ItemQuantity",
        slot: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        fieldDisplay: "false",
        editable: true,
      },
    ];
    const globalFilterFields = ref(Replacementheaders.map((col) => col.field));

    const AddItems = (value) => {
      debugger;
      console.log(value);
      items.value = value;
    };

    //IssueAutoGenerateCode
    let issueCode = "";
    async function GetCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value,
        HospitalId: HospitalId,
        BranchId: FromStoreBranchId,
        StoreId: commonItemProps.value.storeId ?? 0,
      };

      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      issueCode = result;
      if (requestForm.value.issueId == "") {
        let QueryStringValue3: any = route.query;
        let QueryStringValue4: any = route.query;

        console.log(QueryStringValue3);
        QueryStringValue3 = QueryStringValue3.data;
        QueryStringValue4 = QueryStringValue4.param;

        QueryStringValue3 = JSON.parse(QueryStringValue3);
        let dd = QueryStringValue3["requestId"];

        if (QueryStringValue3["requestId"] == "") {
          requestForm.value.issueId = issueCode;
        } else {
          if (QueryStringValue4 == "IndirectIssue") {
            requestForm.value.issueId = issueCode;
          } else {
            requestForm.value.issueId = QueryStringValue3["requestId"];
          }
        }
      }
    }

    let issuereturnCode = "";
    async function GetIssueReturnCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value,
        HospitalId: HospitalId,
        BranchId: FromStoreBranchId,
        StoreId: commonItemProps.value.storeId ?? 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);
      issuereturnCode = result;
      if (requestForm.value.issueReturnId == "") {
        requestForm.value.issueReturnId = issuereturnCode;
      }
    }

    const LoadUOM = ref({
      UOMoption: [],
      UOMId: null,
    });

    // Load UOM
    async function UOM() {
      debugger;
      try {
        const dataresponse = await UnitMasterService.getdata();

        console.log(dataresponse);
        debugger;

        LoadUOM.value.UOMoption = dataresponse["result"]
          .filter((x) => x.HospitalId == HospitalId)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    function ShowUOMDropdown(data) {
      debugger;
      data.Editable = true;
      data.UOMoption = LoadUOM.value.UOMoption;
    }

    //Submit Function Validation
    async function SubmitFunc() {
      debugger;
      let StockInCount = items.value.filter(
        (item) => Number(item["StockInHand"]) < Number(item["ItemQuantity"])
      ).length;
      let QtyCount = items.value.filter(
        (item) => Number(item["ItemQuantity"]) == 0
      ).length;
      let IssueQuantityCount = items.value.filter(
        (item) =>
          Number(item["RequestedQty"]) - Number(item["IssuedQuantity"]) <
          Number(item["ItemQuantity"])
      ).length;
      let IssueItemCount = items.value.filter(
        (item) => Number(item["ItemQuantity"]) != 0
      ).length;
      if (items.value.length == 0) {
        toast.add({
          severity: "warn",
          summary: "Add the Item",
          detail: "Please add an item before proceeding.",
          life: 3000,
        });
        return false;
      } else if (StockInCount > 0) {
        toast.add({
          severity: "warn",
          summary: "Issue Quantity must be less than Available Quantity",
          detail:
            "The issue quantity must be less than the available quantity.",
          life: 3000,
        });
        return false;
      } else if (
        IssueQuantityCount > 0 &&
        Number(requestForm.value.type) == 1
      ) {
        toast.add({
          severity: "warn",
          summary: "Issue Quantity must be less than Requested Quantity",
          detail:
            "The issue quantity must be less than the requested quantity.",
          life: 3000,
        });
        return false;
      } else if (IssueItemCount == 0) {
        toast.add({
          severity: "warn",
          summary: "Issue At Least One Item",
          detail: "Please issue at least one item before proceeding.",
          life: 3000,
        });
        return false;
      } else if (QtyCount > 0) {
        modelQty.value = true;
        return false;
      }
      const CategoryNotMappedCount = items.value.some(
        (item) => item.ToStoreCategoryItem === 1
      );
      if (CategoryNotMappedCount == 0) {
        toast.add({
          severity: "warn",
          summary: "Category Not Mapped",
          detail: "Category Not Mapped To " + requestForm.value.toStoreName,
          life: 3000,
        });
        return false;
      }
      IsSubmit();
    }

    async function IsSubmit() {
      debugger;
      loading1.value = true;
      modelQty.value = false;
      let QueryStringValue1: any = route.query;
      let QueryStringValue2: any = route.query;
      var FileUploadArray: any = [];
      console.log(QueryStringValue1);
      QueryStringValue1 = QueryStringValue1.param;
      let StockOutResult: any;
      if (QueryStringValue1 == "DirectIssue") {
        createrequestForm.value.DocType = "10";
        createrequestForm.value.RefNo = "";
      } else if (QueryStringValue1 == "IndirectIssue") {
        createrequestForm.value.DocType = "11";
        createrequestForm.value.RefNo = requestForm.value.requestId;

        createrequestForm.value.RequestNo = requestForm.value.requestId;
      } else {
        createrequestForm.value.DocType = "13";
      }

      QueryStringValue2 = JSON.parse(QueryStringValue2.data);

      if (QueryStringValue2["type"] == 3) {
        createrequestForm.value.RefId = QueryStringValue2["StockTransId"];
      } else {
        createrequestForm.value.RefId = QueryStringValue2["StockWOTransTMId"];

        createrequestForm.value.RequestId =
          QueryStringValue2["StockWOTransTMId"];
      }

      createrequestForm.value.Id = QueryStringValue2["StockOutTransTMId"];

      createrequestForm.value.StoreId = requestForm.value.fromStoreId;
      createrequestForm.value.FromStore = requestForm.value.fromStoreId;
      createrequestForm.value.ToStore = requestForm.value.toStoreId;

      createrequestForm.value.RefNo = requestForm.value.requestId;
      createrequestForm.value.DocNo = requestForm.value.issueId;

      createrequestForm.value.StoreBrMapId = requestForm.value.StoreBrMapId;
      createrequestForm.value.FromStoreBrMapId =
        requestForm.value.FromStoreBrMapId;
      createrequestForm.value.ToStoreBrMapId = requestForm.value.ToStoreBrMapId;

      createrequestForm.value.FromStoreBranchId =
        requestForm.value.FromStoreBranchId;
      createrequestForm.value.ToStoreBranchId =
        requestForm.value.ToStoreBranchId;

      createrequestForm.value.Remarks = remarks.value.Remarks;
      createrequestForm.value.CreatedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );
      createrequestForm.value.BranchId = FromStoreBranchId;
      createrequestForm.value.HospitalId = HospitalId;
      createrequestForm.value.ModifiedBy = UserId;
      createrequestForm.value.CreatedBy = UserId;
      createrequestForm.value.EntityId = Number(Entitydata.value);
      createrequestForm.value.EntityOperationId = OperationId.value;
      createrequestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

      createrequestForm.value.DocDate = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      createrequestForm.value.Channel = requestForm.value.Channel;
      createrequestForm.value.OrderId = requestForm.value.OrderId;

      let result: any;
      let checkstockAvailabilityresult: any;
      let id: any = 0;
      let msg: String = "";
      let HiddenStockOutMasterId: any = 0;
      let StockInMasterId: any = 0;

      // for (let i = 0; i < items.value.length; i++) {
      //   let obj = {};
      //   if (items.value[i]["ItemQuantity"] > 0) {
      //     (obj["ItemId"] = items.value[i]["ItemId"]),
      //       (obj["BarCodeNo"] = items.value[i]["BarCodeNo"] || 0),
      //       (obj["Qty"] = Number(items.value[i]["ItemQuantity"] || 0)),
      //       (obj["StoreId"] = createrequestForm.value.StoreId || 0),
      //       (obj["BranchId"] = FromStoreBranchId || 0),
      //       (obj["HospitalId"] = HospitalId || 0),
      //       (obj["UOM"] = items.value[i]["UOM"]),
      //       (obj["Brand"] =
      //         items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
      //       (obj["ModelNumber"] =
      //         items.value[i]["ModelNumber"] == null
      //           ? 0
      //           : items.value[i]["ModelNumber"]),
      //       (obj["Size"] =
      //         items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]),
      //       checkstockAvailabilityresultarr.push(obj);
      //   }
      // }
      items.value = items.value.map((items) => {
        items.StoreId = createrequestForm.value.StoreId || 0;
        items.BranchId = FromStoreBranchId || 0;
        items.HospitalId = HospitalId || 0;
        return items;
      });
      debugger;
      checkitem.value = items.value
        .filter(
          (item) => item.ItemQuantity > 0 && item.ToStoreCategoryItem == 1
        )
        .map((items) => {
          // Create a copy of the item to avoid modifying the original
          let itemCopy = { ...items };

          // Temporarily assign replaced values for API call if replacement flag is true
          if (items.ReplacementFlag) {
            itemCopy.Brand = items.ReplacedBrand;
            itemCopy.ModelNumber = items.ReplacedModelNumber;
            itemCopy.Size = items.ReplacedSize;
          }

          return itemCopy;
        });

      checkstockAvailabilityresult = await Itemservice.CheckstockAvailability(
        checkitem.value
      );

      debugger;
      const hasStockStatusOneOrTwo = checkstockAvailabilityresult[
        "result"
      ].some((item) => item.StockStatus === 1 || item.StockStatus === 2);
      const hasStockStatusZeroOrOne = checkstockAvailabilityresult[
        "result"
      ].some((item) => item.StockStatus === 0 || item.StockStatus === 1);
      debugger;
      items.value = items.value.map((item) => {
        let stockItem;

        if (item.ReplacementFlag) {
          stockItem = checkstockAvailabilityresult["result"].find(
            (s) =>
              s.ItemId === item.ItemId &&
              Number(s.BarCodeNo) === Number(item.BarCodeNo) &&
              s.Brand === item.ReplacedBrand &&
              s.ModelNumber === item.ReplacedModelNumber &&
              s.Size === item.ReplacedSize
          );
        } else {
          stockItem = checkstockAvailabilityresult["result"].find(
            (s) =>
              s.ItemId === item.ItemId &&
              Number(s.BarCodeNo) === Number(item.BarCodeNo) &&
              s.Brand === item.Brand &&
              s.ModelNumber === item.ModelNumber &&
              s.Size === item.Size
          );
        }

        if (stockItem) {
          return {
            ...item,
            StockStatus: stockItem.StockStatus,
            ItemQuantity:
              stockItem.StockStatus === 1
                ? stockItem.StockInHand
                : item.ItemQuantity,
            IssuedQuantity:
              stockItem.StockStatus === 1
                ? stockItem.StockInHand
                : stockItem.StockStatus === 0
                ? 0
                : item.ItemQuantity,
          };
        }

        return item; // fallback if no match found
      });
      debugger;

      if (hasStockStatusOneOrTwo) {
        if (
          (QueryStringValue2["type"] == 2 || QueryStringValue2["type"] == 3) &&
          QueryStringValue2["StockOutTransTMId"] != 0
        ) {
          result = await Service.updateStockOutMasterTM(
            createrequestForm.value
          );
          id = QueryStringValue2["StockOutTransTMId"];
        } else if (
          (QueryStringValue2["type"] == 2 &&
            QueryStringValue2["StockOutTransTMId"] == 0) ||
          QueryStringValue2["type"] == 1 ||
          (QueryStringValue2["type"] == 3 &&
            QueryStringValue2["StockTransId"] != 0)
        ) {
          result = await Service.creatStockOutMasterTM(createrequestForm.value);
          id = result["result"];
          HiddenStockOutMasterId = result["result"];
        } else {
          console.log(QueryStringValue2);
        }

        let message = result["ErrorInfo"].ErrorCode;

        if (message == null) {
          debugger;

          for (let i = 0; i < items.value.length; i++) {
            let obj = {};
            let OriginaltItem = ref({
              Brand: 0,
              ModelNumber: 0,
              Size: 0,
            });
            OriginaltItem.value.Brand = items.value[i].Brand;
            OriginaltItem.value.ModelNumber = items.value[i].ModelNumber;
            OriginaltItem.value.Size = items.value[i].Size;
            if (
              items.value[i]["ItemQuantity"] > 0 &&
              items.value[i]["StockStatus"] != 0 &&
              items.value[i].ToStoreCategoryItem == 1
            ) {
              (obj["DocType"] = createrequestForm.value.DocType || 0),
                (obj["StoreId"] = createrequestForm.value.StoreId || 0),
                (obj["Id"] = items.value[i]["StockOutDetailId"] || 0),
                (obj["StockWoDetailId"] =
                  items.value[i]["StockDetailsId"] || 0);

              (obj["ItemId"] = items.value[i]["ItemId"]),
                (obj["Qty"] = items.value[i]["ItemQuantity"]),
                (obj["RefId"] = id),
                (obj["Rate"] = items.value[i]["Rate"]);
              obj["UnitRate"] = items.value[i]["UnitRate"];
              obj["PurchaseTax"] = items.value[i]["PurchasePercentage"];
              obj["PurchaseTaxAmount"] = items.value[i]["Purchasetaxamount"];
              obj["SaleTax"] = items.value[i]["SalesPercentage"];
              (obj["SaleTaxAmount"] = items.value[i]["Salestaxamount"]),
                (obj["PackSizeId"] = items.value[i]["PackageSizeId"] || 0),
                (obj["HSNId"] = items.value[i]["HSNId"]),
                (obj["BarCodeNo"] = Number(items.value[i]["BarCodeNo"] || 0)),
                (obj["BarCode"] = items.value[i]["BarCode"] || "");
              if (items.value[i]["ExpiryDate"]) {
                obj["ExpiryDate"] = moment(
                  items.value[i]["ExpiryDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
              }
              if (
                items.value[i]["ManufactureDate"] &&
                items.value[i]["ManufactureDate"] != "01-01-0001"
              ) {
                obj["ManufactureDate"] = moment(
                  items.value[i]["ManufactureDate"],
                  "DD-MM-YYYY"
                ).format("YYYY-MM-DD");
              } else {
                obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
              }
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
                (obj["ModifiedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["CreatedBy"] = UserId),
                (obj["ModifiedBy"] = UserId),
                (obj["UOM"] = items.value[i]["UOM"]),
                (obj["BatchNo"] = items.value[i]["BatchNo"]),
                (obj["Brand"] =
                  items.value[i]["Brand"] == null
                    ? 0
                    : items.value[i]["Brand"]),
                (obj["ModelNumber"] =
                  items.value[i]["ModelNumber"] == null
                    ? 0
                    : items.value[i]["ModelNumber"]),
                (obj["Size"] =
                  items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);
              (obj["OriginalBrand"] =
                items.value[i]["Brand"] == null ? 0 : items.value[i]["Brand"]),
                (obj["OriginalModelNumber"] =
                  items.value[i]["ModelNumber"] == null
                    ? 0
                    : items.value[i]["ModelNumber"]),
                (obj["OriginalSize"] =
                  items.value[i]["Size"] == null ? 0 : items.value[i]["Size"]);

              obj["ReplacementFlag"] = items.value[i]["ReplacementFlag"]
                ? 1
                : 0;
              (obj["RoomId"] = 0),
                (obj["RackId"] = 0),
                (obj["RowId"] = 0),
                (obj["BoxId"] = 0),
                (obj["IsApproved"] = 0),
                (obj["ConsigneeItem"] = items.value[i]["ConsigneeItem"] || 0),
                (obj["PickStartTime"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["PickEndTime"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                (obj["CurrentStockInHand"] =
                  items.value[i]["StockInHand"] || 0),
                (obj["AssetFlag"] = items.value[i]["Asset"] ? 1 : 0);
              for (let k = 0; k < items.value.length; k++) {
                const element = items.value[k];
                if (element["ItemId"] == items.value[i]["ItemId"]) {
                  let barcodoutearry = {};
                  barcodoutearry["BarCode"] = element["BarCode"];
                  Barcodearr.push(barcodoutearry);
                }
              }
              obj["usedOutBarcode"] = Barcodearr;
              if (obj["ReplacementFlag"] == true) {
                obj["Brand"] =
                  items.value[i]["ReplacedBrand"] == null
                    ? 0
                    : items.value[i]["ReplacedBrand"];
                obj["ModelNumber"] =
                  items.value[i]["ReplacedModelNumber"] == null
                    ? 0
                    : items.value[i]["ReplacedModelNumber"];

                obj["Size"] =
                  items.value[i]["ReplacedSize"] == null
                    ? 0
                    : items.value[i]["ReplacedSize"];
              }
              arr.push(obj);
              Barcodearr = [];
            }
          }
          debugger;
          StockOutResult = await Service.CreateBarcodeStockOut(arr);
          let msgMapping = result["ErrorInfo"].ErrorCode;
          debugger;
          let ConsigneeArr: any = items.value.filter(
            (item: any) => item.ConsigneeItem == 1 && item.ItemQuantity > 0
          );
          if (ConsigneeArr.length > 0) {
            const uniqueSupplierIdsSet = new Set<string>();
            ConsigneeArr.forEach((obj) => {
              uniqueSupplierIdsSet.add(obj.SupplierId);
            });
            const uniqueSupplierIdsArray = Array.from(uniqueSupplierIdsSet);
            for (let i = 0; i < uniqueSupplierIdsArray.length; i++) {
              let itemValue = ConsigneeArr.filter(
                (item) => item.SupplierId == uniqueSupplierIdsArray[i]
              );
              const TotalAmount = itemValue.reduce(
                (accumulator, currentValue) => {
                  return accumulator + currentValue.Totalvalue;
                },
                0
              );
              let requestItem = ref({
                DocType: "4",
                SupplierId: Number(uniqueSupplierIdsArray[i]),
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                BranchId: FromStoreBranchId,
                HospitalId: HospitalId,
                CreatedBy: UserId,
                DocDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                EntityId: 3044,
                EntityOperationId: 3044001,
                StoreId: Number(requestForm.value.fromStoreId),
                FromStore: Number(requestForm.value.fromStoreId),
                ToStore: Number(requestForm.value.toStoreId),
                RefId: id || 0,
                IsConsigneeItem: 1,
                Amount: Number(TotalAmount) || 0,
                Id: 0,
                IsServiceLevel: 0,
                PaymentTermsId: 0,
                DeliveryTermsId: 0,
              });
              var response = await commonServiceWO.createStockWOTM(
                requestItem.value
              );
              let id1 = response["result"];
              msgMapping = response["ErrorInfo"].ErrorCode;
              if (msgMapping == null) {
                let conArr: any = [];
                for (let j = 0; j < itemValue.length; j++) {
                  let obj = {};
                  (obj["Id"] = 0),
                    (obj["IsConsigneeItem"] = 1),
                    (obj["BarCodeNo"] = itemValue[j]["BarCodeNo"]),
                    (obj["ItemId"] = itemValue[j]["ItemId"]),
                    (obj["Qty"] = itemValue[j]["ItemQuantity"]),
                    (obj["RefId"] = id1),
                    (obj["PackSizeId"] = itemValue[j]["PackSizeId"]),
                    (obj["HSNId"] = itemValue[j]["HSNId"]),
                    (obj["CreatedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (obj["ModifiedAt"] = moment().format(
                      "YYYY-MM-DDTHH:mm:ss.SSSZ"
                    )),
                    (obj["CreatedBy"] = UserId),
                    (obj["ModifiedBy"] = UserId),
                    (obj["Rate"] = itemValue[j]["Rate"]),
                    (obj["UnitRate"] = itemValue[j]["UnitRate"]),
                    (obj["Description"] = itemValue[j]["Description"]),
                    (obj["Brand"] =
                      itemValue[j]["Brand"] == null
                        ? 0
                        : itemValue[j]["Brand"]),
                    (obj["ModelNumber"] =
                      itemValue[j]["ModelNumber"] == null
                        ? 0
                        : itemValue[j]["ModelNumber"]),
                    (obj["Size"] =
                      itemValue[j]["Size"] == null ? 0 : itemValue[j]["Size"]);
                  (obj["IsApproved"] = 0), conArr.push(obj);
                }
                result = await commonServiceWO.createStockWODetails(conArr);
                msgMapping = result["ErrorInfo"].ErrorCode;
              }
            }
          }
          if (msgMapping == null) {
            createrequestForm.value.RefId = id;
            createrequestForm.value.RefNo = "";

            createrequestForm.value.StoreId = requestForm.value.toStoreId;
            createrequestForm.value.StoreBrMapId =
              requestForm.value.ToStoreBrMapId;
            createrequestForm.value.BranchId =
              requestForm.value.ToStoreBranchId;

            createrequestForm.value.RequestCreatedBy = RequestCreatedBy.value;
            createrequestForm.value.RequestCreatedBranch =
              requestForm.value.ToStoreBranchId;
            //RequestCreatedBranch.value;

            if (
              (QueryStringValue2["type"] == 2 &&
                QueryStringValue2["StockOutTransTMId"] != 0) ||
              (QueryStringValue2["type"] == 3 &&
                QueryStringValue2["StockOutTransTMId"] != 0 &&
                QueryStringValue2["StockTransId"] != 0)
            ) {
              createrequestForm.value.Id = StockInTransId;
              createrequestForm.value.EntityId = 3050;
              createrequestForm.value.EntityOperationId = 3050002;
              result = await commonService.updateStockInTM(
                createrequestForm.value
              );
              id = StockInTransId;
            } else if (
              (QueryStringValue2["type"] == 2 &&
                QueryStringValue2["StockOutTransTMId"] == 0) ||
              QueryStringValue2["type"] == 1 ||
              (QueryStringValue2["type"] == 3 &&
                QueryStringValue2["StockTransId"] != 0 &&
                QueryStringValue2["StockOutTransTMId"] == 0)
            ) {
              createrequestForm.value.EntityId = 3050;
              createrequestForm.value.EntityOperationId = 3050001;
              result = await commonService.createStockInTM(
                createrequestForm.value
              );
              id = result["result"];
            }
          }
          debugger;
          let message1 = result["ErrorInfo"].ErrorCode;
          let barcodearry: any = ref([]);
          if (message1 == null) {
            debugger;
            let arr1: any = [];
            debugger;
            for (let i = 0; i < items.value.length; i++) {
              let ItemData;
              if (items.value[i]["ReplacementFlag"] == true) {
                ItemData = StockOutResult["result"].filter(
                  (item) =>
                    item.ItemId === items.value[i]["ItemId"] &&
                    item.OriginalBrand == items.value[i]["Brand"] &&
                    item.OriginalModelNumber == items.value[i]["ModelNumber"] &&
                    item.OriginalSize == items.value[i]["Size"] &&
                    item.BatchNo == items.value[i]["BatchNo"]
                );
              } else {
                ItemData = StockOutResult["result"].filter(
                  (item) =>
                    item.ItemId === items.value[i]["ItemId"] &&
                    item.Brand == items.value[i]["Brand"] &&
                    item.ModelNumber == items.value[i]["ModelNumber"] &&
                    item.Size == items.value[i]["Size"] &&
                    item.BatchNo == items.value[i]["BatchNo"]
                );
              }

              if (
                items.value[i].Asset == 0 ||
                (items.value[i].Asset == 1 &&
                  !arr1.some((item) => item.ItemId === items.value[i].ItemId))
              ) {
                for (let j = 0; j < ItemData.length; j++) {
                  let obj = {};
                  barcodearry.value = [];
                  if (
                    items.value[i]["ItemQuantity"] > 0 &&
                    items.value[i]["StockStatus"] != 0 &&
                    items.value[i].ToStoreCategoryItem == 1
                  ) {
                    (obj["Id"] = items.value[i]["StockInDetailsId"] ?? 0),
                      (obj["StockWoDetailId"] =
                        items.value[i]["StockDetailsId"] || 0);

                    (obj["ItemId"] = items.value[i]["ItemId"]),
                      (obj["Qty"] = ItemData[j]["Qty"] || 0.0),
                      (obj["POQty"] = items.value[i]["ItemQuantity"] || 0.0),
                      (obj["RefId"] = id),
                      (obj["PackSizeId"] = items.value[i]["PackSizeId"] || 0),
                      (obj["HSNId"] = items.value[i]["HSNId"] || 0),
                      (obj["UnitMRP"] = items.value[i]["MRP"] || 0),
                      (obj["CreatedAt"] = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                      )),
                      (obj["ModifiedAt"] = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                      )),
                      (obj["CreatedBy"] = UserId),
                      (obj["ModifiedBy"] = UserId),
                      (obj["Rate"] =
                        ItemData[j]["Qty"] * ItemData[j]["UnitRate"] || 0);
                    obj["UnitRate"] = ItemData[j]["UnitRate"] || 0;
                    obj["PurchaseTax"] =
                      items.value[i]["PurchasetaxPercentage"] || 0;
                    obj["PurchaseTaxAmount"] =
                      items.value[i]["Purchasetaxamount"] || 0;
                    obj["SalesTax"] = items.value[i]["SalestaxPercentage"] || 0;
                    obj["SalesTaxAmount"] =
                      items.value[i]["Salestaxamount"] || 0;
                    obj["DiscountPer"] = items.value[i]["Discount"] || 0;
                    obj["DiscountAmount"] =
                      items.value[i]["DiscountAmount"] || 0;
                    obj["ExpiryDate"] = currentDate;
                    obj["ManufactureDate"] = currentDate;
                    obj["TransportCharges"] =
                      items.value[i]["transportcharges"] || 0;
                    obj["ServiceCharges"] =
                      items.value[i]["servicecharges"] || 0;
                    obj["OtherCharges"] = items.value[i]["othercharges"] || 0;
                    obj["BatchNo"] = items.value[i]["BatchNo"] || "";
                    obj["TotalValue"] = items.value[i]["Totalvalue"] || 0;
                    obj["RefBarCodeNo"] = ItemData[j]["BarCodeNo"] || 0;
                    obj["RefBarCode"] = ItemData[j]["BarCode"] || "";
                    obj["Channel"] = requestForm.value.Channel || 0;
                    obj["OrderId"] = requestForm.value.OrderId || 0;
                    obj["HospitalId"] = HospitalId || 0;
                    obj["BranchId"] = Number(BranchId) || 0;
                    obj["StoreId"] = Number(commonItemProps.value.storeId) ?? 0;
                    for (let k = 0; k < items.value.length; k++) {
                      const element = items.value[k];
                      if (element["ItemId"] == ItemData[j]["ItemId"]) {
                        barcodearry.value.push(element);
                        obj["usedBarcode"] = barcodearry.value;
                      }
                    }
                    if (
                      ItemData[j]["ExpiryDate"] != "01-01-0001" &&
                      ItemData[j]["ExpiryDate"]
                    ) {
                      obj["ExpiryDate"] = moment(
                        ItemData[j]["ExpiryDate"],
                        "DD-MM-YYYY"
                      ).format("YYYY-MM-DD");
                    } else {
                      obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
                    }
                    if (
                      ItemData[j]["ManufactureDate"] != "01-01-0001" &&
                      ItemData[j]["ManufactureDate"] != "01-01-1900" &&
                      ItemData[j]["ManufactureDate"]
                    ) {
                      obj["ManufactureDate"] = moment(
                        ItemData[j]["ManufactureDate"],
                        "DD-MM-YYYY"
                      ).format("YYYY-MM-DD");
                    } else {
                      obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
                    }
                    (obj["Brand"] =
                      items.value[i]["Brand"] == null
                        ? 0
                        : items.value[i]["Brand"]),
                      (obj["ModelNumber"] =
                        items.value[i]["ModelNumber"] == null
                          ? 0
                          : items.value[i]["ModelNumber"]),
                      (obj["Size"] =
                        items.value[i]["Size"] == null
                          ? 0
                          : items.value[i]["Size"]);

                    (obj["IsApproved"] = 0),
                      (obj["UOM"] = items.value[i]["UOM"]),
                      (obj["AssetFlag"] = items.value[i]["Asset"] ? 1 : 0);
                    if (items.value[i]["ReplacementFlag"] == true) {
                      obj["Brand"] =
                        items.value[i]["ReplacedBrand"] == null
                          ? 0
                          : items.value[i]["ReplacedBrand"];
                      obj["ModelNumber"] =
                        items.value[i]["ReplacedModelNumber"] == null
                          ? 0
                          : items.value[i]["ReplacedModelNumber"];
                      obj["Size"] =
                        items.value[i]["ReplacedSize"] == null
                          ? 0
                          : items.value[i]["ReplacedSize"];
                    }
                    arr1.push(obj);
                  }
                }
              }
            }

            // Remove duplicates from arr1 based on BarCodeNo
            const uniqueArr1 = arr1.filter(
              (item, index, self) =>
                item.RefBarCodeNo === undefined ||
                self.findIndex(
                  (i) =>
                    i.RefBarCodeNo !== undefined &&
                    i.RefBarCodeNo === item.RefBarCodeNo
                ) === index
            );

            let result1 = await commonService.createStockInDetails(uniqueArr1);
            if (uploadedTableList.value.length != 0) {
              for (let i = 0; i < uploadedTableList.value.length; i++) {
                let Fileobj = {};
                (Fileobj["Id"] = uploadedTableList.value[i].Id),
                  (Fileobj["DocType"] = createrequestForm.value.DocType),
                  (Fileobj["RefId"] = id),
                  (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
                  (Fileobj["CreatedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (Fileobj["CreatedBy"] = UserId),
                  (Fileobj["ModifiedBy"] = 0),
                  (Fileobj["EntityId"] = Number(Entitydata.value)),
                  (Fileobj["IsApproved"] = 0),
                  FileUploadArray.push(Fileobj);
              }
              StockWOFileUpload.value = FileUploadArray;
              let FileUploadResult =
                await StockInFileUploadServices.insertStockWOFile(
                  StockWOFileUpload.value
                );
            }
            if (DeletedFileUpload.length > 0) {
              debugger;
              let result = await StockInFileUploadServices.DeleteList(
                DeletedFileUpload.join(",")
              );
            }

            if (StockWODetailsarr.length != 0) {
              result = await StockWODetailsService.DeletedReasonById(
                StockWODetailsarr
              );
            }
            let msgMapping1 = result1["ErrorInfo"].ErrorCode;

            if (msgMapping1 == null) {
              if (hasStockStatusZeroOrOne) {
                alreadyexistpop.value = true;
                loading1.value = false;
                afterSave.value = true;
                PrintCrystalReport(
                  HiddenStockOutMasterId,
                  FromStoreBranchId,
                  HospitalId
                );
              } else {
                if (
                  (QueryStringValue2["type"] == 2 ||
                    QueryStringValue2["type"] == 3) &&
                  QueryStringValue2["StockOutTransTMId"] != 0
                ) {
                  PrintCrystalReport(
                    HiddenStockOutMasterId,
                    FromStoreBranchId,
                    HospitalId
                  );
                  loading1.value = false;
                  updatepop.value = true;
                } else if (
                  (QueryStringValue2["type"] == 2 &&
                    QueryStringValue2["StockOutTransTMId"] == 0) ||
                  QueryStringValue2["type"] == 1 ||
                  (QueryStringValue2["type"] == 3 &&
                    QueryStringValue2["StockTransId"] != 0)
                ) {
                  PrintCrystalReport(
                    HiddenStockOutMasterId,
                    FromStoreBranchId,
                    HospitalId
                  );
                  loading1.value = false;
                  successpop.value = true;
                }
              }
            }
          }
        }
      } else {
        alreadyexistpop.value = true;
        loading1.value = false;
        afterSave.value = true;
      }
    }

    let StockWODetailsarr: any = [];
    //Item Delete
    async function IsItemDelete(data) {
      debugger;
      let msg = null,
        idChk = "";
      let QueryStringValue1: any = route.query;
      QueryStringValue1 = QueryStringValue1.param;
      console.log(data["StockDetailsId"]);
      console.log(data["StockOutDetailId"]);
      if (QueryStringValue1 == "IndirectIssue") {
        if (data.ReplacementFlag == true) {
          items.value = items.value.filter((item) => {
            return !(item === data);
          });
          return;
        }
        if (data.DeletedReason) {
          StockWODetailsarr.push({
            Id: data.StockDetailsId,
            DeletedReason: data.DeletedReason, // Assuming you want to set the status to 0
          });
          data.ItemQuantity = 0;
          data.DeleteFlag = true;
          deletepop.value = true;
        } else {
          toast.add({
            severity: "warn",
            summary: `Enter Reason For Deleting Item ${data.Itemname1}`,
            detail: "Please provide a reason for deleting this item.",
            life: 3000,
          });
        }
      } else {
        if (commonItemProps.value.itemType == 1) {
          idChk = "BarCodeNo";
        } else {
          idChk = "ItemId";
        }
        if (data["StockOutDetailId"]) {
          const result = await WithoutStockService.deleteStockOutDetails(
            data["StockOutDetailId"]
          );
          msg = result["ErrorInfo"].ErrorCode;
        }
        if (data["StockInDetailsId"]) {
          let result = await commonService.deleteStockInDetails(
            data.StockInDetailsId
          );
          msg = result["ErrorInfo"].ErrorCode;
        }
        if (msg == null) {
          items.value = items.value.filter((item) => {
            if (idChk == "BarCodeNo") {
              return item["" + idChk + ""] != data["" + idChk + ""];
            } else {
              return (
                item["" + idChk + ""] != data["" + idChk + ""] ||
                (data.ModelNumber !== undefined &&
                  item["ModelNumber"] !== data.ModelNumber) ||
                (data.Size !== undefined && item["Size"] !== data.Size) ||
                (data.Brand !== undefined && item["Brand"] !== data.Brand) ||
                (data.BatchNo !== undefined && item["BatchNo"] !== data.BatchNo)
              );
            }
          });
          deletepop.value = true;
        }
      }
      Deletemodel.value = false;
    }

    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
      Editmodel.value = false;
    }

    const getstorevalue = async (value) => {
      debugger;
      debugger;
      console.log(value);
      if (value) {
        commonItemProps.value.storeId = String(requestForm.value.fromStoreId);
        commonItemProps.value.tostoreId = String(requestForm.value.toStoreId);
        commonItemProps.value.ToStoreBrMapId = Number(
          requestForm.value.ToStoreBrMapId
        );
        if (value.FromStoreBrMapId) {
          let FromStoreData = FromStoreresult["result"].filter(
            (items) => items.StoreBranchMapId == value.FromStoreBrMapId
          );
          requestForm.value.fromStoreName = FromStoreData[0].Name;
          requestForm.value.fromStoreCode = FromStoreData[0].Code;
          requestForm.value.FromStoreBranchId = FromStoreData[0].BranchId;
          value.ToStoreBrMapId = value.ToStoreBrMapId.StoreBranchMapId
            ? value.ToStoreBrMapId.StoreBranchMapId
            : value.ToStoreBrMapId;
          await LoadToStore(value.fromStoreId);
          debugger;
          let ToStoreData = ToStoreresult["result"].filter(
            (items) => items.StoreBranchMapId == value.ToStoreBrMapId
          );
          requestForm.value.toStoreName = ToStoreData[0].Name;
          requestForm.value.toStoreCode = ToStoreData[0].Code;
          requestForm.value.ToStoreBrMapId = value.ToStoreBrMapId;
          requestForm.value.toStoreId = value.toStoreId;
          requestForm.value.ToStoreBranchId = ToStoreData[0].BranchId;
          commonItemProps.value.tostoreId = value.toStoreId;
          commonItemProps.value.ToStoreBrMapId = value.ToStoreBrMapId;
        }
      }
    };

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(router, 2);
    }

    function deleteclosetrigger() {
      deletepop.value = false;
    }

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }

    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Deletemodel.value = true;
    }

    function PrintCrystalReport(Id, BranchId, HospitalId) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
      ParameterValues.value.BranchId = BranchId;
      ParameterValues.value.HospitalId = HospitalId;
    }

    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        items.value = [];
        items.value = value;
      }
    };

    function getColorStyle(data) {
      // Check if this is a replacement item

      // Original color logic

      if (data.StockStatus === 1) {
        return { color: "blue" };
      } else if (data.StockStatus === 0) {
        return { color: "red" };
      } else if (data.StockStatus === 2) {
        return { color: "green" };
      }
      // else {
      //   return {}; // Default style (no color change)
      // }
      if (data.StockInHand == 0) {
        return { color: "red" };
      }
      if (data.ReplacementFlag) {
        return { color: "blue", fontWeight: "bold" };
      }
    }

    function reqQtyToQty(data) {
      const stockInHand = Number(data.StockInHand);
      const itemQuantity = Number(data.ItemQuantity);
      const requestedQty = Number(data.RequestedQty);
      const issuedQuantity = Number(data.IssuedQuantity) || 0;
      const requestType = Number(requestForm.value.type);
      if (
        isNaN(stockInHand) ||
        isNaN(itemQuantity) ||
        isNaN(requestedQty) ||
        isNaN(issuedQuantity)
      ) {
        toast.add({
          severity: "warn",
          summary: "Invalid Input",
          detail: "Please provide numeric values.",
          life: 3000,
        });
        data.ItemQuantity = "";
        return;
      }

      const { RequestedQty, ItemId, Size, Brand, ModelNumber } = data;
      const totalQuantity = items.value
        .filter(
          (item) =>
            item.ItemId === ItemId &&
            item.Size === Size &&
            item.Brand === Brand &&
            item.ModelNumber === ModelNumber
        )
        .reduce((sum, item) => sum + Number(item.ItemQuantity), 0);
      const Qty = totalQuantity - Number(data.ItemQuantity);
      if (String(IssusePopupProps.value.type) == "1") {
        if (totalQuantity > RequestedQty - issuedQuantity) {
          toast.add({
            severity: "warn",
            summary: "Issue Quantity must be less than Requested Quantity",
            detail:
              "The issue quantity must be less than the requested quantity.",
            life: 3000,
          });
          data.ItemQuantity = RequestedQty - issuedQuantity - Qty;
          if (Number(data.StockInHand) < data.ItemQuantity) {
            data.ItemQuantity = 0;
          }
          return false;
        }
      }

      if (Number(data.StockInHand) < data.ItemQuantity) {
        toast.add({
          severity: "warn",
          summary: "Issue Quantity must be less than Available Quantity",
          detail:
            "The issue quantity must be less than the available quantity.",
          life: 3000,
        });
        data.ItemQuantity = 0;
        return false;
      }
      return true; // Return true if no issues
    }

    function ReplacementreqQtyToQty(data) {
      debugger;

      if (
        typeof data.ItemQuantity === "string" &&
        data.ItemQuantity !== "" &&
        !/^\d+$/.test(data.ItemQuantity)
      ) {
        toast.add({
          severity: "warn",
          summary: "Invalid Input",
          detail: "Please enter only numeric values.",
          life: 3000,
        });
        data.ItemQuantity = "0";
        data.CheckFlag = false;
        return false;
      }

      if (data.ItemQuantity < 0) {
        data.ItemQuantity = 0;
        return false;
      }

      // Get the current values as numbers
      const newQuantity = Number(data.ItemQuantity || 0);
      const stockInHand = Number(data.StockInHand || 0);

      // Initialize previousQuantity if not set
      if (data.previousQuantity === undefined) {
        data.previousQuantity = 0;
      }

      const previousQuantity = Number(data.previousQuantity);

      // Calculate how much the quantity has changed
      const quantityDifference = newQuantity - previousQuantity;

      // Calculate the maximum allowed quantity (minimum of stock in hand and remaining issue count + previous quantity)
      const maxAllowedQty = Math.min(
        stockInHand,
        IssueCount.value + previousQuantity
      );

      // Case 1: Check if the entered quantity exceeds available stock or remaining issue count
      if (newQuantity > maxAllowedQty) {
        // Determine which limit was exceeded for the appropriate message
        if (newQuantity > stockInHand) {
          toast.add({
            severity: "warn",
            summary: "Issue Quantity must be less than Available Quantity",
            detail:
              "The issue quantity must be less than the available quantity.",
            life: 3000,
          });
        } else {
          toast.add({
            severity: "warn",
            summary: "Exceeds Required Quantity",
            detail: "You can't issue more than the required quantity.",
            life: 3000,
          });
        }

        // Set to the maximum allowed quantity
        data.ItemQuantity = maxAllowedQty;

        // Update IssueCount based on the adjusted quantity
        const adjustedDifference = maxAllowedQty - previousQuantity;
        if (adjustedDifference > 0) {
          // Only reduce IssueCount if we're increasing quantity
          IssueCount.value = Math.max(0, IssueCount.value - adjustedDifference);
        } else if (adjustedDifference < 0) {
          // If decreasing, add back to IssueCount
          IssueCount.value += Math.abs(adjustedDifference);
        }

        data.previousQuantity = maxAllowedQty;

        // Update checkbox state based on quantity
        data.CheckFlag = maxAllowedQty > 0 ? ["true"] : false;

        return false;
      }

      // Case 2: Check if the entered quantity exceeds remaining issue count
      if (quantityDifference > 0) {
        // Only check when increasing quantity
        if (quantityDifference > IssueCount.value) {
          toast.add({
            severity: "warn",
            summary: "Exceeds Required Quantity",
            detail: "You can't issue more than the required quantity.",
            life: 3000,
          });

          // Set to maximum possible (previous + remaining IssueCount)
          data.ItemQuantity = previousQuantity + IssueCount.value;
          IssueCount.value = 0;
          data.previousQuantity = Number(data.ItemQuantity);

          // Update checkbox state based on quantity
          data.CheckFlag = Number(data.ItemQuantity) > 0 ? ["true"] : false;

          return false;
        } else {
          // Valid increase in quantity
          IssueCount.value -= quantityDifference;
        }
      } else if (quantityDifference < 0) {
        // Quantity decreased, add back to IssueCount
        IssueCount.value += Math.abs(quantityDifference);
      }

      // Store the new quantity as previous for next change
      data.previousQuantity = newQuantity;

      // Update checkbox state based on final quantity
      data.CheckFlag = newQuantity > 0 ? ["true"] : false;

      return true;
    }

    function handleAutofill() {
      debugger;
      let errorMessage = "";
      items.value = items.value.map((Lineitem) => {
        if (Lineitem.ReplacementFlag != true) {
          let RequestedQty = Lineitem.RequestedQty - Lineitem.IssuedQuantity;

          const { ItemId, Size, Brand, ModelNumber } = Lineitem;

          const totalItemQuantity = items.value
            .filter(
              (item) =>
                item.ItemId === ItemId &&
                item.Size === Size &&
                item.Brand === Brand &&
                item.ModelNumber === ModelNumber &&
                !item.ReplacementFlag
            )
            .reduce((sum, item) => sum + Number(item.ItemQuantity), 0);
          let BalanceQty = RequestedQty - totalItemQuantity;

          if (BalanceQty <= Number(Lineitem.StockInHand) && BalanceQty != 0) {
            Lineitem.ItemQuantity = BalanceQty;
          } else if (
            BalanceQty > Number(Lineitem.StockInHand) &&
            BalanceQty != 0
          ) {
            Lineitem.ItemQuantity = Number(Lineitem.StockInHand);
          }
          return Lineitem;
        } else {
          errorMessage = "Some items are already filled using replacement.";
          return Lineitem;
        }
      });

      if (errorMessage) {
        toast.add({
          severity: "warn",
          summary: "Warning",
          detail: errorMessage,
          life: 3000,
        });
      }
    }

    const handleChangedocument = async (event: Event) => {
      debugger;
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, "TransactionFiles");
          console.log("Uploaded :", result);
          let ResponseValue = result;
          ResponseValue["Id"] = 0;
          fullPath.value = result.uploadPath;
          uploadedTableList.value.push(ResponseValue);
        }
      }
      debugger;
      console.log(uploadedTableList.value);
    };

    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }

    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id);
      uploadedTableList.value = uploadedTableList.value.filter(
        (item) => item.fileName != data.fileName
      );
    };

    async function GetCampDetails() {
      debugger;
      const result = await WithoutStockService.GetByStockWOTransId(
        requestForm.value.StockWOTransTMId
      );
      if (result["result"][0].IsCamp) {
        ObjCamp.value.IsCamp = result["result"][0].IsCamp;
        ObjCamp.value.CampId = result["result"][0].CampId;
        ObjCamp.value.InstituteName = result["result"][0].InstituteName;
        ObjCamp.value.CampName = result["result"][0].CampName;
        ObjCamp.value.CampType = result["result"][0].CampType;
        ObjCamp.value.CampDate = result["result"][0].CampDate;
        ObjCamp.value.FormattedCampDate = moment(
          result["result"][0].CampDate,
          "MM/DD/YYYY hh:mm:ss A"
        ).format("DD/MM/YYYY");
        ObjCamp.value.ExpectedIP = result["result"][0].ExpectedIP;
        ObjCamp.value.ExpectedOP = result["result"][0].ExpectedOP;
        ObjCamp.value.CampDetailCard = true;
      }
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }

    async function ReplacementItem(data) {
      debugger;
      data.ItemQuantity = 0;
      // Store the current item being replaced to display its details
      let Type = data.BatchRequired == 1 ? 2 : 1;

      currentReplacementItem.value = data;

      const { RequestedQty, IssuedQuantity, ItemId, Size, Brand, ModelNumber } =
        data;
      const totalQuantity = items.value
        .filter(
          (item) =>
            item.ItemId === ItemId &&
            item.Size === Size &&
            item.Brand === Brand &&
            item.ModelNumber === ModelNumber
        )
        .reduce((sum, item) => sum + Number(item.ItemQuantity), 0);
      IssueCount.value =
        RequestedQty -
        IssuedQuantity -
        (totalQuantity - Number(data.ItemQuantity));
      ReplacementTableFlag.value = true;

      const result = await WithoutStockService.GetReplacementItemsByItemId(
        data.ItemId,
        requestForm.value.fromStoreId,
        requestForm.value.toStoreId,
        requestForm.value.FromStoreBranchId,
        requestForm.value.ToStoreBranchId,
        HospitalId,
        data.UOM,
        Type
      );

      debugger;
      ReplacementItemsList.value = result["result"].map((items) => {
        items.StockOutDetailId = data.StockOutDetailId;
        items.ItemQuantity = data.ItemQuantity;
        items.HSNId = data.HSNId;
        items.PurchasePercentage = data.PurchasePercentage;
        items.Purchasetaxamount = data.Purchasetaxamount;
        items.SalesPercentage = data.SalesPercentage;
        items.Salestaxamount = data.Salestaxamount;
        items.ConsigneeItem = data.ConsigneeItem;
        items.ItemProductId = data.ItemProductId;
        items.ItemCategory1 = data.ItemCategory1;
        items.UOMName = data.UOMName;
        items.RequestedQty = data.RequestedQty;
        items.IssuedQuantity = data.IssuedQuantity;
        items.CheckFlag = false;
        items.ReplacementFlag = true;
        items.ToStoreCategoryItem = 1;
        items.StockDetailsId = data.StockDetailsId;
        return items;
      });
    }

    function Replacementcheck(data) {
      debugger;

      if (data.CheckFlag.includes("true")) {
        if (IssueCount.value === 0) {
          toast.add({
            severity: "warn",
            summary: "No Quantity Required",
            detail:
              "You can't select more items as the required quantity is already fulfilled.",
            life: 3000,
          });
          data.CheckFlag = false;
          return false;
        }

        // Store previous quantity before changing
        const previousQuantity = Number(data.ItemQuantity || 0);

        // Calculate optimal quantity (either all remaining IssueCount or max available stock)
        const stockInHand = Number(data.StockInHand || 0);
        const optimalQuantity = Math.min(IssueCount.value, stockInHand);

        // Validate the quantity
        if (optimalQuantity <= 0) {
          toast.add({
            severity: "warn",
            summary: "No Stock Available",
            detail: "There is no stock available for this item.",
            life: 3000,
          });
          data.CheckFlag = false;
          return false;
        }

        // Set the new quantity
        data.ItemQuantity = optimalQuantity;

        // Update IssueCount (only subtract the difference from what was already set)
        const quantityDifference = optimalQuantity - previousQuantity;
        if (quantityDifference > 0) {
          IssueCount.value -= quantityDifference;
        }

        // Store for future reference
        data.previousQuantity = optimalQuantity;

        // Ensure the checkbox stays checked
        data.CheckFlag = ["true"];
      } else {
        // When unchecking the box
        const currentQuantity = Number(data.ItemQuantity || 0);

        // Add the current quantity back to IssueCount
        IssueCount.value += currentQuantity;

        // Reset the item quantity
        data.ItemQuantity = 0;
        data.previousQuantity = 0;
      }
    }

    function ConfirmIssue() {
      debugger;

      const selectedItems = ReplacementItemsList.value.filter((item) => {
        if (Array.isArray(item.CheckFlag)) {
          return item.CheckFlag.includes("true");
        }
        return item.CheckFlag === true || item.CheckFlag === "true";
      });

      if (selectedItems.length >= 1) {
        // Remove the original item that was selected for replacement
        items.value = items.value.filter((item) => {
          // Check if this is the item we're replacing
          return !(
            item.ItemId === currentReplacementItem.value.ItemId &&
            item.Brand === currentReplacementItem.value.Brand &&
            item.ModelNumber === currentReplacementItem.value.ModelNumber &&
            item.Size === currentReplacementItem.value.Size
          );
        });

        // Add selected replacement items to the main items array
        selectedItems.forEach((item) => {
          item.ReplacedBrand = item.Brand;
          item.ReplacedModelNumber = item.ModelNumber;
          item.ReplacedSize = item.Size;
          item.ReplacedBrandName = item.BrandName;
          item.ReplacedModelNumberName = item.ModelNumberName;
          item.ReplacedSizeName = item.SizeName;
          item.Brand = currentReplacementItem.value.Brand;
          item.ModelNumber = currentReplacementItem.value.ModelNumber;
          item.Size = currentReplacementItem.value.Size;
          item.BrandName = currentReplacementItem.value.BrandName;
          item.ModelNumberName = currentReplacementItem.value.ModelNumberName;
          item.SizeName = currentReplacementItem.value.SizeName;
          items.value.push(item);
        });

        // Close the dialog
        ReplacementTableFlag.value = false;

        toast.add({
          severity: "success",
          summary: "Items Replaced",
          detail: `Original item replaced with ${selectedItems.length} replacement item(s).`,
          life: 3000,
        });
      } else {
        toast.add({
          severity: "warn",
          summary: "Add the Item",
          detail:
            "Please pick at least one replacement item before proceeding.",
          life: 3000,
        });
        return false;
      }
    }

    return {
      Itemschanges,
      SubmitFunc,
      reqQtyToQty,
      colourCodeList,
      Entitydata,
      List,
      getstorevalue,
      headers,
      Replacementheaders,
      filters,
      showitemfield,
      ShowItems,
      showadditemfield,
      paramValue,
      requestForm,
      AddItems,
      loading1,
      items,
      showFields,
      IsSubmit,
      createrequestForm,
      issueCode,
      IsItemDelete,
      issuereturnCode,
      remarks,
      IsShowByStockTransId,
      IsShowByStockOutId,
      IsItemEdit,
      display,
      displayClass,
      dataItems,
      successpop,
      updatepop,
      closetrigger,
      IsConfirmDel,
      dataEdit,
      Deletemodel,
      deletepop,
      Editmodel,
      IsConfirmEdit,
      deleteclosetrigger,
      getParamsValue,
      itemDatas,
      commonItemProps,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      getColorStyle,
      ShowUOMDropdown,
      modelQty,
      IssusePopupProps,
      handleAutofill,
      handleChangedocument,
      uploadedTableList,
      fileviewer,
      fileuploadDelete,
      label,
      ObjCamp,
      selectedcontent,
      alreadyexistpop,
      alreadyclosetrigger,
      afterSave,
      DocNo,
      DocNoOpiton,
      GetItemDetails,
      LoadDocNo,
      FromDate,
      ToDate,
      ReplacementItemsList,
      ReplacementTableFlag,
      itemList,
      menu,
      toggle,
      globalFilterFields,
      ReplacementreqQtyToQty,
      Replacementcheck,
      IssueCount,
      currentReplacementItem,
      ConfirmIssue,
    };
  },
});
</script>
<style lang="scss">
.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

.colourCodeStatusBg {
  background-color: #e9e7e7;
  padding: 10px 20px;
  border-radius: 5px;

  .confirmedicon {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
}
</style>
